import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Plans.css';
import { createPortal } from 'react-dom'; 
import { PlanPattern, TemplateForm, ModalWindow } from '../index'
import { getUsersPlans } from '../../../store/api';

export const Plans = () => {
  const { userPlans, statusUserPlan, errorUserPlan } = useSelector(state => state.plans);
  const [userId, setUserId] = useState('');
  const [planId, setPlanId] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();
     const [openForm, setOpenForm] = React.useState(false) 
// Состояние для пагинации
const [currentPage, setCurrentPage] = useState(1);
const [plansPerPage, setPlansPerPage] = useState(20);// Количество планов на странице 


  const MEAL_TITLES = {
    breakfast: 'Завтрак',
    lunch: 'Обед',
    dinner: 'Ужин',
    supper: 'Перекус',
    snack: 'Снек',
    lateDinner: 'Поздний ужин'
  };

  const fetchUserPlans = () => {
    if (!userId.trim()) {
      setError('Введите ID пользователя');
      return;
    }
    dispatch(getUsersPlans(userId));
    setError('');
    setCurrentPage(1)
  };

  // Вычисляем текущие планы для отображения
  const indexOfLastPlan = currentPage * plansPerPage;
  const indexOfFirstPlan = indexOfLastPlan - plansPerPage;
  const currentPlans = userPlans.slice(indexOfFirstPlan, indexOfLastPlan);
  
  // Общее количество страниц
  const totalPages = Math.ceil(userPlans.length / plansPerPage);
  
  // Функции для навигации по страницам
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Генерация массива номеров страниц для отображения
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5; // Максимальное количество отображаемых номеров страниц
    
    if (totalPages <= maxPagesToShow) {
      // Показываем все страницы
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Показываем часть страниц с многоточием
      if (currentPage <= 3) {
        // В начале
        for (let i = 1; i <= 4; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        // В конце
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        // В середине
        pageNumbers.push(1);
        pageNumbers.push('...');
        pageNumbers.push(currentPage - 1);
        pageNumbers.push(currentPage);
        pageNumbers.push(currentPage + 1);
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    
    return pageNumbers;
  };

  const formatDateTime = (dateString, includeTime = false) => {
    if (!dateString) return 'Нет даты';
    return new Date(dateString).toLocaleString('ru-RU', {
      dateStyle: 'short',
      timeStyle: includeTime ? 'short' : undefined
    });
  };

  const calculateMealNutrition = (meal) => {
    if (!meal || !Array.isArray(meal) || meal.length === 0) {
      return { calories: 0, carb: 0, protein: 0, fats: 0 };
    }

    return meal.filter(Boolean).reduce((total, item) => ({
      calories: total.calories + (item.cal || 0),
      carb: total.carb + (item.carb || 0),
      protein: total.protein + (item.protein || 0),
      fats: total.fats + (item.fats || 0)
    }), { calories: 0, carb: 0, protein: 0, fats: 0 });
  };

  const getMealItemName = (item) => {
    if (!item) return 'Удаленный рецепт';
    return item.recipe?.name || 
           (item.recipe?._id ? `Рецепт ${item.recipe._id.substring(0, 8)}...` : 'Без названия');
  };

  const renderMealItem = (item, idx) => {
    if (!item) return null;
    
    return (
      <div key={item._id || idx} className="food-item">
        <div className="food-item-header">
          <span className="food-name">{getMealItemName(item)}</span>
        </div>
        <div className="food-item-details">
          <div className="food-item-nutrition">
            <span>Вес: {item.weight || 0}г</span>
            <span>Порций: {item.servings || 1}</span>
          </div>
          <div className="food-item-nutrition">
            <span>{item.cal?.toFixed(1) || 0} ккал</span>
            <span>Б: {item.protein?.toFixed(1) || 0}г</span>
            <span>Ж: {item.fats?.toFixed(1) || 0}г</span>
            <span>У: {item.carb?.toFixed(1) || 0}г</span>
          </div>
          {item.recipe?.complex && (
            <div className="food-item-complexity">Сложность: {item.recipe.complex}</div>
          )}
          {item.recipe?.timeCooking && (
            <div className="food-item-time">Время готовки: {item.recipe.timeCooking} мин</div>
          )}
        </div>
      </div>
    );
  };

  const renderMealCategory = (meal, mealKey) => {
    if (!meal || !Array.isArray(meal) || meal.length === 0) return null;

    const nutrition = calculateMealNutrition(meal);
    const title = MEAL_TITLES[mealKey] || mealKey;

    return (
      <div className="meal-category">
        <h5>{title}</h5>
        <div className="meal-nutrition">
          <span>Калории: {nutrition.calories.toFixed(1)}</span>
          <span>Б: {nutrition.protein.toFixed(1)}г</span>
          <span>Ж: {nutrition.fats.toFixed(1)}г</span>
          <span>У: {nutrition.carb.toFixed(1)}г</span>
        </div>
        <div className="food-items">
          {meal.map((item, idx) => renderMealItem(item, idx))}
        </div>
      </div>
    );
  };

  const renderPlan = (plan, index) => (
    <div key={plan._id || index} className="plan-card">
      <div className="plan-header">
        <h3>{plan.title || `План ${index + 1}`}</h3>
        <span className="plan-date">{formatDateTime(plan.date)}</span>
      </div>
      
      <div className="plan-info">
        <div className="plan-meta">
          <span><strong>ID:</strong> {plan._id}</span>
          <span><strong>Создан:</strong> {formatDateTime(plan.createdAt, true)}</span>
          <span><strong>Обновлен:</strong> {formatDateTime(plan.updatedAt, true)}</span>
          {plan.owner && <span><strong>Владелец:</strong> {plan.owner.name || plan.owner._id}</span>}
        </div>

        {plan.nutritionTotals && (
          <div className="nutrition-totals">
            <h4>Общая нутрициональная информация:</h4>
            <div className="nutrition-grid">
              <span>Калории: {plan.nutritionTotals.calories?.toFixed(1) || 0}</span>
              <span>Белки: {plan.nutritionTotals.protein?.toFixed(1) || 0}г</span>
              <span>Жиры: {plan.nutritionTotals.fats?.toFixed(1) || 0}г</span>
              <span>Углеводы: {plan.nutritionTotals.carb?.toFixed(1) || 0}г</span>
            </div>
          </div>
        )}

        <div className="meals-section">
          {Object.keys(MEAL_TITLES).map(mealKey => 
            renderMealCategory(plan[mealKey], mealKey)
          )}
        </div>

        {plan.foodList?.length > 0 && (
          <div className="food-list-section">
            <h5>Список продуктов:</h5>
            <div className="food-list">
              {plan.foodList.map((food, idx) => (
                <div key={food._id || idx} className="food-list-item">
                  <span>{food.name || food.ingredient?.name || `Продукт ${idx + 1}`}</span>
                  <span>{food.weight || 0}г</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );

   function handleClose() { 
    setOpenForm(false) 
  }

  function handleOpenForm(id) { 
    setOpenForm(true) 
    setPlanId(id)
  }
  return (
    <>
    <div className="user-plans-admin">
      <h2>Просмотр планов пользователя</h2>
      
      <div className="search-section">
        <input
          type="text"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          placeholder="Введите ID пользователя"
          className="user-id-input"
        />
        <button 
          onClick={fetchUserPlans} 
          disabled={statusUserPlan === 'loading'}
          className="search-button"
        >
          {statusUserPlan === 'loading' ? 'Загрузка...' : 'Получить планы'}
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}
      {errorUserPlan && <div className="error-message">{errorUserPlan}</div>}

      {userPlans.length > 0 && (
        <div className="plans-count">Найдено планов: {userPlans.length}</div>
      )}

      {statusUserPlan === 'loading' && <div className="loading">Загрузка планов...</div>}

      <div className="plans-container">
        {userPlans.length === 0 && statusUserPlan !== 'loading' && currentPlans.length === 0 && (
          <div className="no-plans">
            {userId ? 'Планы не найдены' : 'Введите ID пользователя для поиска планов'}
          </div>
        )}

        {userPlans.length > 0 && statusUserPlan !== 'loading' &&
        currentPlans.map((item) => ( 
                      <PlanPattern
                        item={item} 
                        key={item._id}
                      /> 
                  ))} 
      </div>
      {/* Пагинация */}
        {totalPages > 1 && (
          <div className="plans-pagination">
            <div className="pagination-controls">
              <button 
                onClick={prevPage} 
                disabled={currentPage === 1 || statusUserPlan === 'loading'}
                className="pagination-btn"
              >
                ← Назад
              </button>
              
              <div className="page-numbers">
                {getPageNumbers().map((pageNum, index) => (
                  pageNum === '...' ? (
                    <span key={`ellipsis-${index}`} className="page-ellipsis">...</span>
                  ) : (
                    <button
                      key={pageNum}
                      onClick={() => goToPage(pageNum)}
                      className={`page-number ${currentPage === pageNum ? 'active' : ''}`}
                      disabled={statusUserPlan === 'loading'}
                    >
                      {pageNum}
                    </button>
                  )
                ))}
              </div>
              
              <button 
                onClick={nextPage} 
                disabled={currentPage === totalPages || statusUserPlan === 'loading'}
                className="pagination-btn"
              >
                Вперед →
              </button>
            </div>
            
            <div className="pagination-info">
              <label>
                Планов на странице:
                <select 
                  value={plansPerPage} 
                   onChange={(e) => setPlansPerPage(Number(e.target.value))}
                   className="page-size-select"
                 >
                   <option  value="20">20</option>
                  <option  value="50">50</option>
                  <option   value="100">100</option>
                  <option   value="150">150</option> 
                </select>
              </label>
            </div>
          </div>
        )}
    </div>

     {openForm && createPortal(
        <ModalWindow  isOpen={openForm} onClose={handleClose} title='show-recipe' head='Параметры меню' >
      <TemplateForm 
        planId={planId}    
      /> 
    </ModalWindow>, 
       document.body
       )}

    </>
  );
};